import React from 'react';
import { useUser, useConfig, useAuth, useAuthInfo, useAuthChange, useAuthStatus } from './hooks';

/**
 * Higher-Order Component that wraps a class component with auth-related props
 * Provides access to user and config data from the AuthContext
 *
 * @param {React.Component} WrappedComponent - The class component to wrap
 * @returns {React.Component} - A new component with auth props injected
 */
export function withAuth(WrappedComponent) {
  return function WithAuthComponent(props) {
    // Get data from hooks
    const user = useUser();
    const config = useConfig();
//    const auth = useAuth();
//    const authInfo = useAuthInfo();
    const [authChangeState, authChangeEvent] = useAuthChange();
    const [authStatusState, authStatusInfo] = useAuthStatus();

    // Pass all auth-related data as props to the wrapped component
    return (
      <WrappedComponent
        user={user}
        config={config}
//        auth={auth}
//        authInfo={authInfo}
        authChangeState={authChangeState}
        authChangeEvent={authChangeEvent}
        authStatusState={authStatusState}
        authStatusInfo={authStatusInfo}
        {...props}
      />
    );
  };
}

/**
 * Example usage:
 *
 * class MyComponent extends React.Component {
 *   render() {
 *     const { user, config } = this.props;
 *
 *     if (!user) {
 *       return <div>Loading user...</div>;
 *     }
 *
 *     return (
 *       <div>
 *         <h1>Welcome, {user.name}!</h1>
 *         <p>App Version: {config.version}</p>
 *       </div>
 *     );
 *   }
 * }
 *
 * export default withAuth(MyComponent);
 */
